// 接品路由配置
import React from "react";

const Home = React.lazy(() => import('./Home' /* webpackChunkName:"NPM_Home" */));


const routers = [
    {
        path: '/',
        component: Home,
    },

]

export default routers;

